import getQueryUtils, { attributeKeys } from './queryUtils';
import REQUIRED_FIELDS_PUBLIC from './REQUIRED_FIELDS_PUBLIC';
import { useConnect } from '@lore/query-connect';
import queryString from 'query-string';

export default function useQuery(props) {
  const {
    search = {},
    pageSize = 4
  } = props;

  const queryUtils = getQueryUtils(search, attributeKeys);

  return useConnect('offer.find', {
    where: {
      eager: {
        $where: {
          $and: [
            ...queryUtils.where,
            ...REQUIRED_FIELDS_PUBLIC.$and
          ]
        }
      }
    },
    pagination: {
      page: queryString.parse(location.search).page || '1',
      pageSize: pageSize,
      order: search.order || 'createdAt desc'
    }
  }, { keepPreviousData : true });
}
